import { QUESTION_BASE_TYPE } from "@/lib/schema/configuration/question_conditional";
import { SalesforceFieldTypes } from "@/types/crm/salesforce/fields";

export const SALESFORCE_FIELD_TYPES = [
    'radio',
    'checkbox',
    'number',
    'currency',
    'date',
    // 'file',
    // 'pick_group_rank',
    // 'picklist',
    // 'picklist_multiple',
    // 'rank',
    'slider',
    'text',
    'textarea',
] as const;

export const salesforceFieldTypesBaseTypes: Record<SalesforceFieldTypes, typeof QUESTION_BASE_TYPE[number]> = {
    'radio': 'text',
    'checkbox': 'list',
    'text': 'text',
    // 'rank': 'number',
    // 'file': 'text',
    // 'pick_group_rank': 'number',
    'slider': 'number',
    'currency': 'number',
    'date': 'number',
    'textarea': 'text',
    'number': 'number',
    // 'picklist': 'text',
    // 'picklist_multiple': 'list'
}
